import { useParams, Navigate } from 'react-router-dom';
import PublicHeader from '../components/PublicHeader.jsx';
import Footer from '../components/Footer.jsx';
import { useTitle } from '../lib/useTitle.js';
import { useMetaTags } from '../lib/useMetaTags.js';
import { findArticle, relatedArticles } from '../content/learn/_articles.js';

export default function LearnArticle() {
  const { slug } = useParams();
  const article = findArticle(slug);

  useTitle(article?.title);
  useMetaTags({
    description: article?.description,
    ogTitle: article?.title,
    ogDescription: article?.description,
    ogType: 'article',
    canonical: article ? `https://mytrainforge.com/learn/${article.slug}` : undefined,
    jsonLd: article ? articleSchema(article) : undefined,
  });

  if (!article) return <Navigate to="/learn" replace />;

  const Component = article.component;
  const related = relatedArticles(article.slug, 3);

  return (
    <div>
      <PublicHeader />
      <Component related={related} />
      <Footer />
    </div>
  );
}

function articleSchema(article) {
  const url = `https://mytrainforge.com/learn/${article.slug}`;
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.description,
    datePublished: article.date,
    mainEntityOfPage: url,
    image: 'https://mytrainforge.com/og-image.png',
    author: { '@type': 'Organization', name: 'TrainForge', url: 'https://mytrainforge.com/' },
    publisher: {
      '@type': 'Organization',
      name: 'TrainForge',
      logo: { '@type': 'ImageObject', url: 'https://mytrainforge.com/app-icon-1024.png' },
    },
  };
}
